export const guestSections = [
    { id: "home", label: "Home" },
    { id: "overview", label: "Group" },
    { id: "plan", label: "Plan" },
    { id: "stays", label: "Stays" },
    { id: "money", label: "Money" },
    { id: "receipts", label: "Receipts" },
    { id: "memories", label: "Media" },
    { id: "launch", label: "Start" },
] as const;

export const memberSections = [
    { id: "home", label: "Home" },
    { id: "continue", label: "Trips" },
    { id: "plan", label: "Plan" },
    { id: "stays", label: "Stays" },
    { id: "money", label: "Money" },
    { id: "receipts", label: "Receipts" },
    { id: "memories", label: "Media" },
    { id: "launch", label: "Start" },
] as const;
